import { h } from 'preact';

function Key({ className, children }) {
  return (
    <div class={`border text-xs tracking-normal border-gray-300 text-gray-500 font-medium bg-gradient-to-b from-white to-gray-100 rounded flex items-end px-1.5 py-0.5 relative select-none ${className}`}>
      {children}
      <span class="absolute h-1.5 border-b inline-block border-l border-r border-gray-300 -bottom-1 -left-px -right-px rounded-b-md" />
    </div>
  );
}

Key.defaultProps = {
  className: '',
};

export default Key;
